<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.45797 21.2876C6.18187 18.7635 2.33398 15.7988 2.33398 10.6596C2.33398 4.98616 8.75084 0.962675 14.0007 6.41704L16.334 8.74879C16.6758 9.09044 17.2298 9.09034 17.5714 8.74857C17.9131 8.4068 17.913 7.85278 17.5712 7.51113L15.3172 5.25794C20.2639 1.63657 25.6673 5.45339 25.6673 10.6596C25.6673 15.7988 21.8194 18.7635 18.5433 21.2876C18.2028 21.55 17.8685 21.8075 17.5453 22.0623C16.334 23.0172 15.1673 23.9163 14.0007 23.9163C12.834 23.9163 11.6673 23.0172 10.456 22.0623C10.1328 21.8075 9.79848 21.55 9.45797 21.2876Z"
      fill="white" style="fill:white;fill-opacity:1;"
    />
  </svg>
</template>
